module.exports = __webpack_public_path__ + "static/img/14000042.92fc2f91.png";